import { render, staticRenderFns } from "./FilterTextAttr.vue?vue&type=template&id=2a4565c1&scoped=true"
import script from "./FilterTextAttr.vue?vue&type=script&lang=js"
export * from "./FilterTextAttr.vue?vue&type=script&lang=js"
import style0 from "./FilterTextAttr.vue?vue&type=style&index=0&id=2a4565c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4565c1",
  null
  
)

export default component.exports